import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAppContext } from '../../appProvider/contextProvider';
import Loader from '../../components/Loader/loader';
import LogoContainer from '../../components/LogoContainer';
import PreLoginBanner from '../../components/PreloginBanner';
import { Email_VALIDATOR, ERRORS } from '../../constants/AppConstants';
import { resetPassword } from '../../services/userService';


const ForgotPassword = () => {

    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(null);
    const [timer, setTimer] = useState(null);

    const {isFetching, isMutating} = useAppContext();

    const getResetLink = useMutation((event) => {
        event.preventDefault();
        return resetPassword({email})
    }, 
     {
        onSuccess: ((response) => {
            if(response.errors) {
                handelError(response.errors)
            } else {
                toast.success(`${response.detail}`,  {
                    autoClose: 5000,
                    position: 'bottom-right'
                });
                setTimer(30);
            }
            
        }),
        onError: ((error) => {
            console.log(error)
            // toast.error('Something went wrong');
        })
    });
    const history = useHistory();

    useEffect(() => {
        const interval = setInterval(() => {
            if(timer && timer >= 0) {
                setTimer(timer - 1);
            } else {
                clearInterval(interval);
                setTimer(null);
            }
        }, 1000);
        return () => {clearInterval(interval)};
    }, [timer])

    const handelEmailValidation = (value) => {
        if(value.length <= 0 ) {
            setEmailError(ERRORS.EMAIL_REQUIRED);
        }
        else if(!value.match(Email_VALIDATOR)) {
            setEmailError(ERRORS.IN_VALID_EMAIL);
        } else {
            setEmailError(null);
        }
        setEmail(value)
    }

    const isFormDisabled = () => email.length <= 0 || emailError;

    const navigateTo = route => {
        history.push(route);
    }

    const handelError = (error) => {
        if(error.email) {
            toast.error(ERRORS[error.email[0]], {
                autoClose: 5000,
                position: 'bottom-right'
            });
        }
    }


    return <> <div className={!!(isMutating || isFetching) ? 'row no-gutters page-container loader full-height p-0':  'row no-gutters full-height'}>
    {!!(isMutating || isFetching) && <Loader />}
        <div className="col col-12 col-lg-6">
            <div className="login-container d-flex flex-column justify-content-center full-height">                
                <LogoContainer />
                <h3 className="text-primary mb-2">Reset Your Password</h3>
                <p className="text-light mb-4">Send Notifications and Track your engagement!</p>
                <div className="form-group">                   
                    <label className="form-label">Email <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-mail"></i>
                        <input 
                            type="email"
                            placeholder="Enter Your Email"
                            className="form-control"
                            value={email}
                            onChange={({target}) => handelEmailValidation(target.value)}
                        />                     
                    </div>                    
                    {emailError && <span className="error-message">{emailError}</span>}                 
                </div>
                <button className="btn tbn-block btn-primary my-3" disabled={isFormDisabled() || timer} onClick={getResetLink.mutate} >{ !timer ? 'Get Reset Link' : `Get Reset Link Again After 00:${('0' + (timer)).slice(-2)}`}</button>
                <a className="text-center text-dark anchor-none" onClick={() => navigateTo('/login')}><i className="icon icon-chevron-left mr-2 "></i>Back to Login</a>
            </div>
        </div>
        <PreLoginBanner />
    </div>
    </>
}

export default ForgotPassword;